<template>
    <v-dialog
        v-model="dialog"
        max-width="500px"
        scrollable
    >
        <v-card flat color="#004889">
            <v-card-title class="accent">
                <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row" v-for="phase in phases" :key="phase.id">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">{{ phase.title }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="justify-end">
                            <v-switch
                                v-model="phase.notification"
                                inset
                                color="secondary"
                            ></v-switch>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card-text> 
        </v-card>
    </v-dialog>
</template>
<script>
    import axios from 'axios'
    import { mapActions } from 'vuex'

    export default {
        props: ['dialog'],
        data: () => ({
            loading: false,
            phases: []
        }),

        computed: {
            formTitle () {
                return 'Manage Notifications'
            },
        },

        watch: {
            dialog (val) {
                this.$emit('update-dialog', val)
            },
        },

        created () {
            this.getPhases()
        },

        methods: {
            ...mapActions({
                getData: 'data/getData',
            }),
            close() {
                this.$emit('update-dialog', false)
            },
            getPhases() {
                this.loading = true
                axios.get('crm/job/phase/get')
                    .then(response => {
                        this.loading = false
                        this.phases = response.data
                        this.$nextTick()
                    })
            },
            async save () {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    axios.post('crm/category/field/add', this.editedItem).then(response => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.getData()
                        this.$emit('update-categories', response.data)
                        this.close()
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },
        },
    }
</script>